import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

const milestones = [
  { year: '2020', title: '星空影院成立', desc: '创始团队怀揣对影视的热爱，正式成立星空影院平台，致力于为用户提供优质的在线追剧体验。' },
  { year: '2021', title: '内容库突破5000部', desc: '与多家内容提供商达成合作，剧集资源库迅速扩充，韩剧、美剧、国产剧全面覆盖。' },
  { year: '2022', title: '上线4K超清画质', desc: '全面升级播放技术，支持4K超清画质播放，同时优化CDN加速，实现全球流畅观影。' },
  { year: '2023', title: '月活用户突破百万', desc: '凭借优质内容和流畅体验获得用户认可，月活跃用户突破百万大关，成为知名影视导航平台。' },
  { year: '2024', title: 'AI智能推荐上线', desc: '引入AI智能推荐算法，根据用户观影偏好精准推荐剧集，提升追剧体验。' },
];

const testimonials = [
  {
    name: '追剧达人小王',
    text: '星空影院真的是我每天必刷的网站！韩剧更新超快，基本播出当天晚上就能看到了，画质也很棒，强烈推荐！',
    rating: 5,
  },
  {
    name: '美剧迷小李',
    text: '找了好久的《继承之战》全集终于在这里看完了，字幕质量很高，没有乱七八糟的广告弹窗，追剧体验满分。',
    rating: 5,
  },
  {
    name: '剧荒拯救者',
    text: '高分榜单真的拯救了我的剧荒！按照评分从高到低刷了好多部，每一部都实至名归，感谢星空影院的推荐。',
    rating: 5,
  },
  {
    name: '国产剧爱好者',
    text: '国产剧资源太全了，《狂飙》《繁花》《三体》这些热门剧集都有，还有详细的剧情介绍和演员信息，收藏了！',
    rating: 5,
  },
];

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于星空影院',
    description: '星空影院聚合热播电视剧、高分剧集全集在线观看，韩剧在线、美剧在线、国产剧大全免费追剧，超清画质不缓冲流畅播放。了解星空影院的品牌故事与联系方式。',
    url: 'https://www.xingkongyingyuan.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '星空影院',
      url: 'https://www.xingkongyingyuan.com',
    },
    about: {
      '@type': 'Organization',
      name: '星空影院',
      description: '热播电视剧高分剧集全集在线观看平台',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'service@xingkongyingyuan.com',
        telephone: '400-888-6666',
      },
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main className="pt-20">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-8">
          <Breadcrumb items={breadcrumbItems} />

          <section className="mt-6 mb-14">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
                关于星空影院
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                星空影院聚合热播电视剧、高分剧集全集在线观看，韩剧在线、美剧在线、国产剧大全免费追剧。
                我们致力于为每一位追剧爱好者提供超清画质、不缓冲的流畅观影体验。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
              <div className="p-6 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-4">
                  <i className="ri-movie-2-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">海量资源</h3>
                <p className="text-sm text-foreground-600">12,000+部剧集资源，涵盖韩剧、美剧、国产剧、日剧、泰剧等多元化内容</p>
              </div>
              <div className="p-6 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-4">
                  <i className="ri-4k-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">超清画质</h3>
                <p className="text-sm text-foreground-600">支持4K HDR超清画质播放，全球CDN加速确保流畅不卡顿</p>
              </div>
              <div className="p-6 rounded-lg bg-background-100 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-4">
                  <i className="ri-refresh-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">每日更新</h3>
                <p className="text-sm text-foreground-600">每日50+部剧集更新，热播剧集播出24小时内即可在线观看</p>
              </div>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-10">
              发展历程
            </h2>
            <div className="relative max-w-3xl mx-auto">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2"></div>
              <div className="flex flex-col gap-8">
                {milestones.map((m, index) => (
                  <div
                    key={m.year}
                    className={`relative flex items-start gap-6 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className="hidden md:flex flex-1"></div>
                    <div className="absolute left-3 md:left-1/2 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50 -translate-x-1/2 z-10 mt-1"></div>
                    <div className="flex-1 pl-10 md:pl-0">
                      <div className="p-5 rounded-lg bg-background-100 border border-background-200">
                        <span className="text-xs text-primary-500 font-semibold">{m.year}</span>
                        <h3 className="text-base font-semibold text-foreground-900 mt-1 mb-2">{m.title}</h3>
                        <p className="text-sm text-foreground-600 leading-relaxed">{m.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-10">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {testimonials.map((t) => (
                <div key={t.name} className="p-6 rounded-lg bg-background-100 border border-background-200">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm text-primary-500"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">{t.text}</p>
                  <p className="text-xs text-foreground-500 font-medium">{t.name}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-10">
              联系我们
            </h2>
            <div className="max-w-2xl mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="p-6 rounded-lg bg-background-100 border border-background-200 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-600">service@xingkongyingyuan.com</p>
                </div>
                <div className="p-6 rounded-lg bg-background-100 border border-background-200 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                    <i className="ri-phone-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服热线</h3>
                  <p className="text-xs text-foreground-600">400-888-6666</p>
                </div>
                <div className="p-6 rounded-lg bg-background-100 border border-background-200 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                    <i className="ri-time-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h3>
                  <p className="text-xs text-foreground-600">周一至周日 9:00-21:00</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}